/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { previewContactSocialProfilesResponseDtoSchema } from "../previewContactSocialProfilesResponseDtoSchema";
import { z } from "zod/v4";

export const enrichContactSocialProfilesPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const enrichContactSocialProfilesQueryParamsSchema = z.object({
    "platforms": z.optional(z.array(z.enum(["linkedin", "instagram", "facebook"])).describe("Restrict the lookup to these platforms. Platforms the contact already has a link for are always skipped, regardless of this filter. Defaults to every platform missing a link."))
    }).optional()

export const enrichContactSocialProfilesHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Looks up LinkedIn/Instagram/Facebook candidates for the contact and returns them for review.
 */
export const enrichContactSocialProfiles200Schema = z.lazy(() => previewContactSocialProfilesResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const enrichContactSocialProfiles401Schema = z.any()

/**
 * @description Another enrichment lookup is already running for this tenant — retry shortly
 */
export const enrichContactSocialProfiles409Schema = z.any()

export const enrichContactSocialProfilesMutationResponseSchema = z.lazy(() => enrichContactSocialProfiles200Schema)